import { makeRequest, CommonRequestOptions } from '../makeRequest';

export type WikiQuizRevision = {
   wiki_quiz_revisionid: number;
   wikiid: number;
   wiki_revisionid: number;
   quizid: number;
   quiz_revisionid: number;
};

export async function createWikiQuizRevision(
   wikiid: number,
   quizid: number,
   { ...common }: CommonRequestOptions
): Promise<WikiQuizRevision> {
   return makeRequest('post', '/quizzes/attach/wiki', {
      ...common,
      body: {
         wikiid,
         quizid,
      },
   });
}
